import React from 'react'
import { useParams, useNavigate } from 'react-router';
import { Button } from '../../components/ui/button/Button';
import { useQuery } from '@tanstack/react-query';
import { productApi } from "../../api/productQuery/productApi"
import { ScrollArea } from '../../components/ui/scrollArea/ScrollArea';
import { MarkupLayout } from '../../components/ui/markupLayout/MarkupLayout';
import { ProductCarousel } from '../../components/productPage/productCarousel/ProductCarousel';
import styles from "./poductPage.module.css"
import { RelatedProductsCarousel } from '../../components/productPage/relatedProductsCarousel/RelatedProductsCarousel';
import { Loader } from '../../components/ui/loader/Loader';

export function ProductPage() {
    const navigate = useNavigate();

    const { productId, engineId } = useParams()

    const { data: products, isLoading: isLoadingProducts, isError: isErrorProducts } = useQuery({ ...productApi.getProductById(productId) })

    let engineIdForRequest = engineId ? engineId : products?.engine_id

    const { data: relatedProducts, isLoading: isLoadingRelatedProducts, isError: isErrorRelatedProducts } = useQuery({
        ...productApi.getRelatedProducts(engineIdForRequest),
        enabled: !!engineIdForRequest
    });

    if (isLoadingProducts || isLoadingRelatedProducts) {
        return <MarkupLayout><Loader /></MarkupLayout>
    }

    if (isErrorProducts || isErrorRelatedProducts) {
        navigate('/error');
        return null;
    }


    return (
        <>
            <MarkupLayout>
                <section className={styles.product_section}>
                    <div className={styles.information_wrapper}>
                        <ProductCarousel data={products.product_images} />
                        <div className={styles.specifications_wrapper}>
                            <span className={styles.name}>{products.name_ru} {products.item_code}</span>
                            <div className={styles.specifications_holder}>
                                <p className={styles.specification}>Характеристики</p>
                                {products?.product_info.map((item) => {
                                    return <p key={item.name}>{item.name} {item.code}</p>
                                })}
                            </div>
                            {/* <Button variant={"dark-blue"}>Скачать характеристики PDF</Button> */}
                        </div>

                    </div>

                    <div className={styles.scrollArea_container}>
                        <div className={styles.scrollArea_holder} >  <span className={styles.name}>OEM</span>  <ScrollArea data={products.oem?.data} keey={"key"} val={"value"} /></div>
                        <div className={styles.scrollArea_holder} >  <span className={styles.name}>REFS</span>      <ScrollArea data={products.refs?.data} keey={"key"} val={"value"} /></div>
                    </div>
                    <span className={styles.products_h} >Сопутствующие товары</span>
                    <RelatedProductsCarousel data={relatedProducts} />
                </section>
            </MarkupLayout>

        </>
    )
}
